import { createSlice } from "@reduxjs/toolkit";
import {
  LocalStorageKey,
  removeLocalStorage,
  saveLocalStorage,
} from "@util/storage";

export interface IUser {
  id: string;
  name: string;
  email: string;
  email_verified_at: null;
  is_superadmin: boolean;
  position_id: number;
  rank_id: number;
  unit_id: number;
  organization_id: number;
  created_at: string;
  updated_at: string;
  deleted_at: null;
  paraf: null;
  signature: null;
  keycloak_id: string;
  position: Position;
  rank: Rank;
  unit: Unit;
  organization: Organization;
  groups: string[];
  roles: Array<{
    id: string;
    code: "pimpinan" | "spri" | "taud" | "urtu" | "urmin" | "anggota";
    description: string;
    pivot?: {
      user_id: string;
      role_id: string;
    };
  }>;
}

interface Organization {
  id: number;
  created_at: string;
  updated_at: string;
  deleted_at: null;
  parent_id: null;
  name: string;
  slug: string;
  alias_name: string;
  logo: null;
  level: string;
  description: null;
  address: null;
}

interface Unit {
  id: number;
  created_at: null;
  updated_at: null;
  deleted_at: null;
  name: string;
  parent_id: null;
  organization_id: number;
  alias_name: string;
  description: null;
}

interface Rank {
  id: number;
  created_at: null;
  updated_at: null;
  deleted_at: null;
  name: string;
  code: number;
  group: string;
  alias_name: string;
}

interface Position {
  id: number;
  created_at: string;
  updated_at: string;
  deleted_at: null;
  name: string;
  parent_id: null;
  alias_name: string;
  organization_id: number;
}

export const initialState: IUser = {
  id: "",
  name: "",
  email: "",
  email_verified_at: null,
  is_superadmin: false,
  position_id: 0,
  rank_id: 0,
  unit_id: 0,
  organization_id: 0,
  created_at: "",
  updated_at: "",
  deleted_at: null,
  paraf: null,
  signature: null,
  keycloak_id: "",
  position: {
    id: 0,
    created_at: "",
    updated_at: "",
    deleted_at: null,
    name: "",
    parent_id: null,
    alias_name: "",
    organization_id: 0,
  },
  rank: {
    id: 0,
    created_at: null,
    updated_at: null,
    deleted_at: null,
    name: "",
    code: 0,
    group: "",
    alias_name: "",
  },
  unit: {
    id: 0,
    created_at: null,
    updated_at: null,
    deleted_at: null,
    name: "",
    parent_id: null,
    organization_id: 0,
    alias_name: "",
    description: null,
  },
  organization: {
    id: 0,
    created_at: "",
    updated_at: "",
    deleted_at: null,
    parent_id: null,
    name: "",
    slug: "",
    alias_name: "",
    logo: null,
    level: "",
    description: null,
    address: null,
  },
  groups: [],
  roles: [],
};

export const userSlice = createSlice({
  name: "notificationMsg",
  initialState,
  reducers: {
    reset: (state) => {
      Object.assign(state, initialState);
      removeLocalStorage(LocalStorageKey.User);
    },
    update: (state, action) => {
      Object.assign(state, action.payload);
      saveLocalStorage(LocalStorageKey.User, state, true);
    },
  },
});

export const { reset, update } = userSlice.actions;

export default userSlice.reducer;
